// extracted by mini-css-extract-plugin
export var header = "productAttribute-module--header--a642f";
export var listMargin = "productAttribute-module--listMargin--50d72";
export var noMargin = "productAttribute-module--noMargin--0070e";
export var sectionMargin = "productAttribute-module--sectionMargin--86664";
export var specificationHeader = "productAttribute-module--specificationHeader--6b48b";
export var text = "productAttribute-module--text--c7a9a";